import { render, staticRenderFns } from "./SVGGrouping.vue?vue&type=template&id=2d7c99ba&scoped=true&"
import script from "./SVGGrouping.vue?vue&type=script&lang=js&"
export * from "./SVGGrouping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7c99ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d7c99ba')) {
      api.createRecord('2d7c99ba', component.options)
    } else {
      api.reload('2d7c99ba', component.options)
    }
    module.hot.accept("./SVGGrouping.vue?vue&type=template&id=2d7c99ba&scoped=true&", function () {
      api.rerender('2d7c99ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGGrouping.vue"
export default component.exports